import React from "react";
import {
	Box,
	Grid,
	Button,
	TextField,
	Typography
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";

const Filter = (props) => {
	const {
		filter,
		onReset,
		onChange,
		onSubmit
	} = props;
	const classes = useStyles();

	const [isOpen, setOpen] = React.useState(true);
	const handleChangeOpen = () => {
		setOpen(!isOpen)
	};

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;
		let _filter = {...filter};
		_filter[name] = value;
		onChange(_filter);
	}

	return (
		<Box className={classes.root}>
			<Grid container justifyContent="space-between" alignItems="center">
				<Grid item>
					<Typography variant="h3" textAlign="left">Поиск по приемке авто</Typography>
				</Grid>
				<Grid item>
					<Button
						size="small"
						variant="outlined"
						onClick={handleChangeOpen}
					>{isOpen ? 'Свернуть' : 'Развернуть'}</Button>
				</Grid>
			</Grid>
			<VisibleContent visible={Boolean(isOpen)}>
				<Box mt={2}/>
				<Grid container spacing={1}>
					<Grid item xs={2}>
						<TextField
							value={filter.tricepsOrderId}
							size="small"
							name="tricepsOrderId"
							variant="outlined"
							label="Номер заявки"
							fullWidth={true}
							onChange={handleChangeFilter}
						/>
					</Grid>
					<Grid item xs={3}>
						<TextField
							value={filter.client}
							size="small"
							name="client"
							variant="outlined"
							label="Клиент"
							fullWidth={true}
							onChange={handleChangeFilter}
						/>
					</Grid>
					<Grid item xs={3}>
						<TextField
							value={filter.mechanic}
							size="small"
							name="mechanic"
							variant="outlined"
							label="Исполнитель"
							fullWidth={true}
							onChange={handleChangeFilter}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							value={filter.vin}
							size="small"
							name="vin"
							variant="outlined"
							label="VIN"
							fullWidth={true}
							onChange={handleChangeFilter}
						/>
					</Grid>
					<Grid item xs={2}>
						<Grid container wrap="nowrap" spacing={1} justifyContent="flex-end">
							<Grid item>
								<Button
									size="small"
									variant="contained"
									sx={{height: 43, padding: "0 32px"}}
									onClick={onSubmit}
								>Применить</Button>
							</Grid>
							<Grid item>
								<Button
									size="small"
									variant="outlined"
									sx={{height: 43, padding: "0 32px"}}
									onClick={onReset}
								>Сбросить</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</VisibleContent>
		</Box>
	)
};
const VisibleContent = ({ visible, children }) => {
	if (!visible) return null
	return children
}

const useStyles = makeStyles(() => ({
	root: {
		marginBottom: "20px",
		padding: "20px",
		paddingTop: "16px",
		boxSizing: "border-box",
		background: "white",
		borderRadius: "14px",
		border: "1px solid #F0F0F0",
	}
}));

export default Filter
